<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100">
    <div fxLayout="column" fxLayoutAlign="center center">
      <Teranet-PageTitle [PageTitle]="'Password Security Recovery Questions'"></Teranet-PageTitle>
      <form [formGroup]="passwordSecurityForm" #userFormRef="ngForm" (ngSubmit)="OnSubmit()">
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Password</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   [type]="'password'"
                   formControlName="password"
                   [(ngModel)]="passwordSecurityModel.password"
                   autocomplete="current-password"
                   required />
            <mat-error *ngIf="passwordSecurityForm.get('password').hasError('required')">
              {{ passwordSecurityErrorMessage.CURRENT_PASSWORD_REQUIRED }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Security Question 1</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <mat-select required formControlName="setOneQuestion" [(ngModel)]="passwordSecurityModel.answerList[0].passwordSecurityQuestionId" placeholder="--Please Select--">
              <mat-option *ngFor="let item of questionList | slice:0:6" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="passwordSecurityForm.get('setOneQuestion').hasError('required')">
              {{ passwordSecurityErrorMessage.QUESTION_REQUIRED }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Answer 1</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   formControlName="setOneAnswer"
                   [(ngModel)]="passwordSecurityModel.answerList[0].answer"
                   required />
            <mat-error *ngIf="passwordSecurityForm.get('setOneAnswer').hasError('required')">
              {{ passwordSecurityErrorMessage.ANSWER_REQUIRED }}
            </mat-error>
            <mat-error *ngIf="passwordSecurityForm.get('setOneAnswer').hasError('minlength')">
              {{ passwordSecurityErrorMessage.ANSWER_LENGTH_ATLEAST }} {{ passwordSecurityForm.get('setOneAnswer').errors.minlength.requiredLength }} characters
            </mat-error>
            <mat-error *ngIf="passwordSecurityForm.get('setOneAnswer').hasError('mustNotMatch')">
              {{ passwordSecurityErrorMessage.ANSWER_NOT_SAME_AS_OTHER_ANSWER }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Security Question 2</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <mat-select required formControlName="setTwoQuestion" [(ngModel)]="passwordSecurityModel.answerList[1].passwordSecurityQuestionId" placeholder="--Please Select--">
              <mat-option *ngFor="let item of questionList | slice:6:12" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="passwordSecurityForm.get('setTwoQuestion').hasError('required')">
              {{ passwordSecurityErrorMessage.QUESTION_REQUIRED }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Answer 2</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   formControlName="setTwoAnswer"
                   [(ngModel)]="passwordSecurityModel.answerList[1].answer"
                   required />
            <mat-error *ngIf="passwordSecurityForm.get('setTwoAnswer').hasError('required')">
              {{ passwordSecurityErrorMessage.ANSWER_REQUIRED }}
            </mat-error>
            <mat-error *ngIf="passwordSecurityForm.get('setTwoAnswer').hasError('minlength')">
              {{ passwordSecurityErrorMessage.ANSWER_LENGTH_ATLEAST }} {{ passwordSecurityForm.get('setTwoAnswer').errors.minlength.requiredLength }} characters
            </mat-error>
            <mat-error *ngIf="passwordSecurityForm.get('setTwoAnswer').hasError('mustNotMatch')">
              {{ passwordSecurityErrorMessage.ANSWER_NOT_SAME_AS_OTHER_ANSWER }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Security Question 3</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <mat-select required formControlName="setThreeQuestion" [(ngModel)]="passwordSecurityModel.answerList[2].passwordSecurityQuestionId" placeholder="--Please Select--">
              <mat-option *ngFor="let item of questionList | slice:12:18" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="passwordSecurityForm.get('setThreeQuestion').hasError('required')">
              {{ passwordSecurityErrorMessage.QUESTION_REQUIRED }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" class="form-group-flex-column">
          <mat-label class="required-field-after">Answer 3</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   formControlName="setThreeAnswer"
                   [(ngModel)]="passwordSecurityModel.answerList[2].answer"
                   required />
            <mat-error *ngIf="passwordSecurityForm.get('setThreeAnswer').hasError('required')">
              {{ passwordSecurityErrorMessage.ANSWER_REQUIRED }}
            </mat-error>
            <mat-error *ngIf="passwordSecurityForm.get('setThreeAnswer').hasError('minlength')">
              {{ passwordSecurityErrorMessage.ANSWER_LENGTH_ATLEAST }} {{ passwordSecurityForm.get('setThreeAnswer').errors.minlength.requiredLength }} characters
            </mat-error>
            <mat-error *ngIf="passwordSecurityForm.get('setThreeAnswer').hasError('mustNotMatch')">
              {{ passwordSecurityErrorMessage.ANSWER_NOT_SAME_AS_OTHER_ANSWER }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="isChangeSaved" fxLayout="row wrap" fxLayoutAlign="end">
          <button mat-raised-button class="plain-button" type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button class="theme-button" type="submit" [disabled]="!passwordSecurityForm.valid">Save</button>
        </div>
      </form>
      <div [hidden]="isChangeSaved">
        <div *ngIf="(isError != undefined) && isError" class="alert alert-danger" role="alert">
          <div>{{ passwordSecurityErrorMessage.FOLLOWING_ERRORS_FOUND }}</div>
          <ul *ngFor="let item of errorMessage">
            <li>{{ item }}</li>
          </ul>
        </div>
      </div>
      <div [hidden]="!isChangeSaved">
        <div class="alert alert-success" role="alert">
          {{ passwordSecurityErrorMessage.CHANGES_TO_QUESTIONS_SAVED }}
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="end">
          <button mat-raised-button class="theme-button" type="submit" (click)="onOk()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
